import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import "./AdminDashboard.css";

function AdminDashboard() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/admin/login");
  };

  const sections = [
    {
      icon: "📚",
      title: "الدورات",
      text: "إضافة وتعديل وحذف الدورات والبرامج التعليمية.",
      path: "/admin/courses",
    },
    {
      icon: "👨‍🏫",
      title: "المدربون",
      text: "إدارة معلومات وصور المدربين.",
      path: "/admin/trainers",
    },

    {
      icon: "🏆",
      title: "الإنجازات",
      text: "إدارة إنجازات ومراتب طلاب مركز مداد.",
      path: "/admin/achievements",
    },

  
  ];

  return (
    <div className="admin-dashboard">

      {/* SIDEBAR */}

      <aside className="admin-sidebar">

        <div className="admin-sidebar-logo">

          <div className="admin-logo-small">
            M
          </div>

          <div>
            <small>MADAD</small>
            <strong>مداد</strong>
          </div>

        </div>

        <div className="admin-sidebar-title">
          لوحة التحكم
        </div>

        <nav className="admin-menu">

          <button
            className="admin-menu-active"
            type="button"
            onClick={() => navigate("/admin")}
          >
            <span>▦</span>
            الرئيسية
          </button>

          <button
            type="button"
            onClick={() => navigate("/admin/courses")}
          >
            <span>📚</span>
            الدورات
          </button>

          <button
            type="button"
            onClick={() => navigate("/admin/trainers")}
          >
            <span>👨‍🏫</span>
            المدربون
          </button>

        

          <button
            type="button"
            onClick={() => navigate("/admin/achievements")}
          >
            <span>🏆</span>
            الإنجازات
          </button>

      


        </nav>

        <button
          className="admin-logout"
          type="button"
          onClick={handleLogout}
        >
          ↪ تسجيل الخروج
        </button>

      </aside>


      {/* MAIN */}

      <main className="admin-main">

        <header className="admin-header">

          <div>
            <span className="admin-header-tag">
              MADAD ADMIN
            </span>

            <h1>
              لوحة التحكم 👋
            </h1>

            <p>
              أهلاً بكِ في لوحة تحكم مركز مداد
            </p>
          </div>

          <div className="admin-user">

            <div className="admin-user-icon">
              M
            </div>

            <div>
              <strong>
                المديرة
              </strong>

              <span>
                Administrator
              </span>
            </div>

          </div>

        </header>


        {/* WELCOME */}

        <section className="admin-welcome">

          <div>

            <span>
              إدارة مركز مداد
            </span>

            <h2>
              كل محتوى موقعك
              <br />
              من مكان واحد.
            </h2>

            <p>
              أضيفي وعدّلي الدورات، الصور، الأخبار،
              الإنجازات والمدربين بسهولة بدون الحاجة
              لتعديل الكود.
            </p>

          </div>

          <div className="admin-welcome-icon">
            M
          </div>

        </section>


        {/* SECTIONS */}

        <section className="admin-section">

          <div className="admin-section-heading">

            <div>
              <span>
                إدارة المحتوى
              </span>

              <h2>
                ماذا تريدين أن تديري؟
              </h2>
            </div>

          </div>


          <div className="admin-cards">

            {sections.map((section) => (

              <button
                className="admin-card"
                key={section.title}
                type="button"
                onClick={() => navigate(section.path)}
              >

                <div className="admin-card-icon">
                  {section.icon}
                </div>

                <div className="admin-card-content">

                  <h3>
                    {section.title}
                  </h3>

                  <p>
                    {section.text}
                  </p>

                </div>

                <span className="admin-card-arrow">
                  ←
                </span>

              </button>

            ))}

          </div>

        </section>

      </main>

    </div>
  );
}

export default AdminDashboard;